import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State } from 'app/e-form/model/eform-type';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-upload-properties',
  templateUrl: './upload-properties.component.html',
  styleUrls: ['./upload-properties.component.scss']
})
export class UploadPropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Output() sendFocus = new EventEmitter<boolean>();
   helper = new EFormHelper();
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;
  constructor() { }

   ngOnInit(): void {
      this.helper.checkDisplayDisabled(this.eForm, this.state);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state);
      });
   }

  replacementInt(keys: string, value: string) {
     let _temp;
     switch (value) {
        case '0' : _temp = 1; break;
        case '' :  _temp = value; break;
        default : _temp = + value; break;
     }
     this.getField.get(keys).setValue(_temp);
  }

  sendFocusToCreate(focus: boolean) {
   this.sendFocus.emit(focus);
}

  get getField() {
    return this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
  }

   restrictMaximumSize(event: Event): void {
      const inputElement = event.target as HTMLInputElement;
      let value = parseInt(inputElement.value, 10);
      if (value > 2048) {
         inputElement.value = '2048';
      }
   }


}
